import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Shield, Users } from 'lucide-react';
import { Button } from './ui/button';
import { useAuth } from '../contexts/AuthContext';

const AreaToggle = () => {
    const { isAdmin } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    if (!isAdmin) return null;

    const isAdminArea = location.pathname.startsWith('/admin');

    return (
        <Button
            variant="outline"
            size="sm"
            className={`flex items-center gap-2 bg-white/5 border-white/10 text-white transition-all duration-300 shadow-sm ${isAdminArea
                    ? 'hover:bg-emerald-500/20 hover:border-emerald-500/50 hover:text-emerald-400'
                    : 'hover:bg-amber-500/20 hover:border-amber-500/50 hover:text-amber-400'
                }`}
            onClick={() => navigate(isAdminArea ? '/members' : '/admin')}
            data-testid="area-toggle-button"
        >
            {isAdminArea ? (
                <>
                    <Users className="h-4 w-4 text-emerald-400" />
                    <span className="hidden sm:inline font-medium">Switch to Members</span>
                </>
            ) : (
                <>
                    <Shield className="h-4 w-4 text-amber-400" />
                    <span className="hidden sm:inline font-medium">Switch to Admin</span>
                </>
            )}
        </Button>
    );
};

export default AreaToggle;
